import { fetchToken, fetchTokenFile } from "../helpers/fetch";
import { const_routes } from "../helpers/const_routes";

const handleAuth = (body, dispatch) => {
  if (body?.code === "bak-aut-tok-exp-001" || body?.code === "bak-aut-tok-inv-001") {
    dispatch({ type: "[Auth] Logout" });
  }
};

export const startDownloadRecordExcelTemplate = (process, expectedName, roleKey, expectedId, matrixMode, subjectKind = "") => async (dispatch) => {
  const query = [
    `name=${encodeURIComponent(expectedName || "")}`,
    `id=${encodeURIComponent(expectedId || "")}`,
    `role_key=${encodeURIComponent(roleKey || "")}`,
    `matrix_mode=${encodeURIComponent(matrixMode || "")}`,
    `subject_kind=${encodeURIComponent(subjectKind || "")}`
  ].join("&");
  const resp = await fetchToken(
    const_routes.SCHEMA,
    const_routes.VERSIONV1,
    const_routes.ROUTE_RECORD_EXCEL_UPDATE,
    `${process}/download-template?${query}`
  );
  if (!resp.ok) {
    const body = await resp.json().catch(() => ({}));
    handleAuth(body, dispatch);
    return { ok: false, msg: body.msg };
  }
  const blob = await resp.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  const safeName = String(expectedId || expectedName || "registro").replace(/[^a-zA-Z0-9._-]/g, "_");
  link.download = `update_${process}_${safeName}.xlsx`;
  link.click();
  window.URL.revokeObjectURL(url);
  return { ok: true };
};

export const startDownloadMassiveModuleExcel = (process, roleKey, matrixMode) => async (dispatch) => {
  const query = [
    `role_key=${encodeURIComponent(roleKey || "")}`,
    `matrix_mode=${encodeURIComponent(matrixMode || "")}`
  ].join("&");
  const resp = await fetchToken(
    const_routes.SCHEMA,
    const_routes.VERSIONV1,
    const_routes.ROUTE_RECORD_EXCEL_UPDATE,
    `${process}/download-massive?${query}`
  );
  if (!resp.ok) {
    const body = await resp.json().catch(() => ({}));
    handleAuth(body, dispatch);
    return { ok: false, msg: body.msg };
  }
  const blob = await resp.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  const mode = String(matrixMode || "matriz").replace(/[^a-zA-Z0-9._-]/g, "_");
  link.download = `matriz_${process}_${mode}.xlsx`;
  link.click();
  window.URL.revokeObjectURL(url);
  return { ok: true };
};

export const startDownloadRecordExcelErrors = (process, bagRowProcess, roleKey, matrixMode, subjectKind = "") => async (dispatch) => {
  const resp = await fetchToken(
    const_routes.SCHEMA,
    const_routes.VERSIONV1,
    const_routes.ROUTE_RECORD_EXCEL_UPDATE,
    `${process}/download-errors`,
    { bagRowProcess, role_key: roleKey || "", matrix_mode: matrixMode || "", subject_kind: subjectKind || "" },
    "POST"
  );
  if (!resp.ok) {
    const body = await resp.json().catch(() => ({}));
    handleAuth(body, dispatch);
    return { ok: false, msg: body.msg };
  }
  const blob = await resp.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `update_${process}_errors.xlsx`;
  link.click();
  window.URL.revokeObjectURL(url);
  return { ok: true };
};

export const startRecordExcelUpdate = ({
  process,
  file,
  apply,
  expectedName,
  expectedId,
  roleKey,
  matrixMode,
  subjectKind = "",
  selectedRowNumber = ""
}) => async (dispatch) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("apply", apply ? "true" : "false");
  formData.append("expected_name", expectedName || "");
  formData.append("expected_id", expectedId || "");
  formData.append("role_key", roleKey || "");
  formData.append("matrix_mode", matrixMode || "");
  formData.append("subject_kind", subjectKind || "");
  formData.append("selected_row_number", selectedRowNumber || "");
  const resp = await fetchTokenFile(
    const_routes.SCHEMA,
    const_routes.VERSIONV1,
    const_routes.ROUTE_RECORD_EXCEL_UPDATE,
    `${process}/import`,
    formData,
    "POST"
  );
  const body = await resp.json();
  handleAuth(body, dispatch);
  return body;
};
